<script>
  import { Modal } from 'bootstrap';
  export let onBulkAction;
  import FormTextarea from '../FormControls/FormTextarea.svelte';
  import { configItem } from 'components/Helper.js';
  let clientNotes = '';
  let id = '';
  let modal;
  export const show = (row) => {
    clientNotes = row.clientNotes != undefined ? row.clientNotes : '';
    id = row.id != undefined ? row.id : '';
    modal = new Modal(document.getElementById('setClientNotes'), {
      keyboard: false,
    });
    modal.show();
  };
  export const hide = () => {
    onBulkAction({
      comeFrom: 'clientNotes',
      id,
      clientNotes,
    });
    modal.hide();
  };
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="setClientNotes"
  tabindex="-1"
  aria-labelledby="setClientNotesModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id="exampleModalLabel"
        >
          Notes for Client
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <div class="row">
            <div class="col-md-12">
              <FormTextarea
                label="Notes for Client"
                maxLength={configItem.maxLength.description}
                placeholder="Enter Notes for Client..."
                name="clientNotes"
                bind:value={clientNotes}
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          class="btn btn-primary m-0 px-4 font-size-12"
          data-bs-dismiss="modal"
          on:click={() => {
            hide();
          }}>Save</button
        >
      </div>
    </div>
  </div>
</div>
